/* @ngInject */
const myAreaForm = (
  $$area
) => {
  return {
    restrict: 'E',
    scope: {
      myArea: '=',
      enableValidator: '=?',
    },
    template: require('./myAreaForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = $$area.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myAreaForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/directives/forms/myAreaForm.js